import React from "react";

import { SongQueryManagement } from "@components/SongQuery";

export default function SongQueryIndex() {
  return <SongQueryManagement />;
}
